import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HumanizePipe } from 'src/app/shared/shared-base/amg-ui/humanize.pipe';

@NgModule({
  declarations: [HumanizePipe],
  imports: [CommonModule],
  exports: [HumanizePipe],
})
export class AmgHumanizeModule {}
